import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { executeTaggeo } from '../../../store/actions';
import { assignTagServiceTelcel } from '../utils';

const Container = styled.div`
	margin: ${props => props.margin ? props.margin : "10px 3% -15px 3%"};
	padding: 0px;
`;

const PlansUpsell = ({ 
	selectedPlan, 
	margin, 
	isContainerTelcel,  
	selectNextPlan, 
	cardInfo,
	tagServiceId,
	executeTaggeo,
	serviceId,
	appSyncValues
}) => {

	return (
		<>
			{
				isContainerTelcel && 
				selectedPlan && 
				selectedPlan.promotions && 
				selectedPlan.promotions.PromotionAccountN2Change &&
				cardInfo &&
				cardInfo.value &&
				appSyncValues &&
				appSyncValues.banks &&
				appSyncValues.banks[0] &&
				appSyncValues.banks[0].toggles &&
				(
					(cardInfo.value === "claro-pay" && appSyncValues.banks[0].toggles.SHOW_MEGAS_GIFT_N2) ||
					(cardInfo.value !== "claro-pay" && appSyncValues.banks[0].toggles.SHOW_MEGAS_GIFT_CARD)
				) 
					?
						<Container margin={ margin } >
							<img 
								src={selectedPlan.promotions.PromotionAccountN2Change} 
								style={{ width: "100%" }} 
								onClick={
									() => {
										executeTaggeo({
											action: "Click Cambiar paquete",
											package: String(selectedPlan.cost),
											service: assignTagServiceTelcel(serviceId, tagServiceId),
											step: "Formulario de pago"
										}),
										selectNextPlan()										
									}
								} />
						</Container>
					:
						<></>
			}
		</>
	)

}

const mapStateToProps = (state) => {
	const { payments } = state;
	const { isContainerTelcel, cardInfo, PAYMENT_SERVICE_CONF, appSyncValues } = payments;
	return {
		isContainerTelcel,
		cardInfo,
		tagServiceId: PAYMENT_SERVICE_CONF.tagServiceId,
		appSyncValues
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			executeTaggeo
		},
		dispatch
	)
}

export default connect(mapStateToProps, mapDispatchToProps)(PlansUpsell);